export default __webpack_public_path__ + "static/media/Icon21.3a3b7099.svg";